import moment from "moment";
import { hasItems } from "../../../helpers/utils";

const __getJournalsFromElements = (
  elements,
  start,
  end,
  journalHash = {},
  isEditMode = false,
) => {
  if (!hasItems(elements)) return;

  elements.forEach((elem) => {
    const isSelected = !isEditMode || elem.isSelected;
    if (isSelected && elem.timeline && hasItems(elem.timeline.gems)) {
      // Filter gems by current period
      elem.timeline.gems.forEach((gem) => {
        if (gem && gem.gem_id && gem.day) {
          const gemDate = moment(gem.day);

          if (gemDate.isBetween(start, end, "minutes", "[)")) {
            journalHash[gem.gem_id] = {
              ...gem,
              element: {
                id: elem.item_id, 
                icon: elem.icon,
                name: elem.name,
                target_type: elem.item_type,
              },
            };
          }
        }
      });
    }
    __getJournalsFromElements(
      elem.children,
      start,
      end,
      journalHash,
      isEditMode,
    );
  });
};

const getAllGems = (reflections, userSelectedDate, timeUnit, isEditMode) => {
  const journalHash = {};

  const userDate = moment(userSelectedDate);
  const tu = timeUnit == "week" ? "isoWeek" : timeUnit;
  const start = userDate.clone().startOf(tu);
  const end = userDate.clone().endOf(tu);

  __getJournalsFromElements(reflections, start, end, journalHash, isEditMode);

  return Object.values(journalHash);
};

const ReportsHelper = {
  getAllGems,
};

export default ReportsHelper;
